import { useMemo, useRef, useState } from 'react';
import { WebSection } from '@wbk/contentful/api';
import Context, { LocalWebCard } from './context';

type Props = {
  children: React.ReactNode;
  anchors?: WebSection;
};

const ZonesProvider = ({ children, anchors }: Props) => {
  const targetRef = useRef<HTMLElement | null>(null);
  const [localAnchors, setAnchors] = useState<WebSection | undefined>(anchors);
  const [localSelectedAnchorCard, setSelectedAnchorCard] = useState<LocalWebCard | null>(
    (anchors?.contentCollection?.items?.[0] as LocalWebCard) || null
  );

  const handleSetAnchors = (anchors: WebSection | undefined) => {
    setAnchors(anchors);
  };

  function handleSetSelectedAnchorCard(card: LocalWebCard | null) {
    setSelectedAnchorCard(card);
  }

  const value = useMemo(() => {
    return {
      anchors: localAnchors,
      setAnchors: handleSetAnchors,
      targetRef: targetRef,
      setSelectedAnchorCard: handleSetSelectedAnchorCard,
      selectedAnchorCard: localSelectedAnchorCard,
    };
  }, [localAnchors, targetRef, localSelectedAnchorCard]);

  return <Context.Provider value={value}>{children}</Context.Provider>;
};

export default ZonesProvider;
